import isResellerMiddleware from '@/router/middlewares/isResellerMiddleware';
import ResellerCreate from '_modules/reseller/views/ResellerCreate.vue';
import ResellerEdit from '_modules/reseller/views/ResellerEdit.vue';
import ResellerList from '_modules/reseller/views/ResellerList.vue';
import Reseller from './Root.vue';


export default {
  path: 'parceiros/',
  component: Reseller,
  name: 'admin-reseller',
  redirect: '/parceiros/lista/1',
  children: [
    {
      beforeEnter: isResellerMiddleware,
      path: 'lista/:page',
      name: 'admin-reseller-list',
      component: ResellerList,
    },
    {
      beforeEnter: isResellerMiddleware,
      path: 'novo/',
      name: 'admin-reseller-new',
      component: ResellerCreate,
    },
    {
      path: 'perfil',
      name: 'admin-reseller-perfil',
      component: ResellerEdit,
    },
    {
      beforeEnter: isResellerMiddleware,
      path: ':resellerId',
      name: 'admin-reseller-edit',
      component: ResellerEdit,
    },
  ],
};
